function convertFrontToBack (address) {
  const tempRefs = address.map((elm, index) => {
    if (Object.values(elm).some(e => { return e })) {
      return convertRefregrant(elm, index)
    }
  })
  const refs = tempRefs.filter(elm => {
    return elm !== undefined
  })
  const tempRcs = address.map((elm, index) => {
    if (elm.rc) {
      return {
        Address: index
      }
    }
  })
  const controllers = tempRcs.filter(elm => {
    return elm !== undefined
  })
  return {
    'refregerant': refs,
    'controller': controllers
  }
}

function convertRefregrant (displayData, addressNo) {
  const configs = []
  for (let key in displayData) {
    if (displayData[key]) {
      configs.push(key)
    }
  }
  const result = configs.reduce((acc, cur) => {
    if (cur === 'oc_adp1' || cur === 'oc_adp2') {
      acc['OC'] += 1
    }
    if (cur.startsWith('ic')) {
      let idx = Number(cur.match(/ic(\d{1})/)[1]) - 1
      acc['IC'][idx] += 1
    }
    return acc
  },
  {
    Address: addressNo,
    OC: 0,
    IC: [-1, -1, -1, -1]
  })
  result.IC.forEach((elm, idx) => {
    if (elm === -1) {
      result.IC.splice(idx)
    }
  })
  return result
}

module.exports = convertFrontToBack
